import React from 'react';
import styled from 'styled-components';
import DownloadIcon from 'icons/src/Download';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';
import Section from '../components/section';
import VariantButton from '../components/variant-button';

const Download = ({
  rowOptions,
  text,
  button,
  className,
}) => (
  <Section
    className={className}
    id={rowOptions?.sectionId || ''}
    backgroundColor={rowOptions?.backgroundColor}
    hideBottomSpacing={rowOptions?.hideBottomSpacing}
    hideTopSpacing={rowOptions?.hideTopSpacing}
    hideRow={rowOptions?.hideRow}
  >
    <Container small>
      <Wrapper>
        <Content $content={text} />
        <StyledButton
          variant={button.variant}
          key={button.id}
          to={button.link}
        >
          <Icon />
          {button.text}
        </StyledButton>
      </Wrapper>
    </Container>
  </Section>
);

const Icon = styled(DownloadIcon)`
  width: 1rem;
  margin-right: .5rem;
`;

const StyledButton = styled(VariantButton)`
  margin-top: 1rem;
`;

const Wrapper = styled.div`
  text-align: center;
`;

export default Download;
